export function validUser (that,user) {
    if(!user.name||!user.enterprise_name||!user.address||!user.unified_social_credit_code||!user.legal_representative||!user.legal_representative_id
    ||!user.enterprise_nature||!user.established_time||!user.contact_number||!user.other_phone||!user.education_degree||!user.professional_qualification_level
    ||!user.contact_user_name||!user.contact_work_department||!user.contact_post||!user.contact_mobile_phone||!user.name_of_branch_of_enterprise_entering_guizhou){
        return false;
    }
    return true;
}
